export const referencesRoot = '/references'

export const referencesRoute = {
  list: '/',
  createChooseType: '/create',
  create: '/create/:type',
}
